import script from "./ListarTransferenciasContas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarTransferenciasContas.vue?vue&type=script&setup=true&lang=js"

import "./ListarTransferenciasContas.vue?vue&type=style&index=0&id=080b0809&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080b0809"]])

export default __exports__